import { css } from '@emotion/react';
import { useState } from 'react';
import { getBuildInfo, getServerEnv, isDev } from './BuildInfo';

export default function DevBuildOverlay() {
  const [expanded, setExpanded] = useState(false);

  if (!isDev()) {
    return null;
  }

  const buildInfo = getBuildInfo();
  const serverEnv = getServerEnv();

  return (
    <div
      css={styles.container}
      onClick={() => setExpanded(!expanded)}
      title="Click to expand/collapse"
    >
      {expanded ? (
        <div css={styles.expanded}>
          <div css={styles.row}>
            <span css={styles.label}>Commit:</span>
            <span css={styles.value}>{buildInfo.gitCommit}</span>
          </div>
          <div css={styles.row}>
            <span css={styles.label}>Built:</span>
            <span css={styles.value}>
              {new Date(buildInfo.buildTime).toLocaleString()}
            </span>
          </div>
          {serverEnv && (
            <>
              <div css={styles.divider} />
              <div css={styles.row}>
                <span css={styles.label}>Host:</span>
                <span css={styles.value}>{serverEnv.hostname}</span>
              </div>
              <div css={styles.row}>
                <span css={styles.label}>HTTP:</span>
                <span css={styles.value}>
                  {serverEnv.httpPort || 'default'}
                </span>
              </div>
              <div css={styles.row}>
                <span css={styles.label}>Channel:</span>
                <span css={styles.value}>
                  {serverEnv.channelPort || 'default'} ({serverEnv.channelMode})
                </span>
              </div>
            </>
          )}
        </div>
      ) : (
        <span css={styles.collapsed}>{buildInfo.gitCommit}</span>
      )}
    </div>
  );
}

const styles = {
  container: css({
    position: 'fixed',
    bottom: 8,
    right: 8,
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    color: '#ccc',
    fontFamily: 'monospace',
    fontSize: 11,
    padding: '4px 8px',
    borderRadius: 4,
    cursor: 'pointer',
    zIndex: 9999,
    userSelect: 'none',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.85)',
    },
    '@media print': {
      display: 'none',
    },
  }),
  collapsed: css({
    opacity: 0.7,
  }),
  expanded: css({
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  }),
  row: css({
    display: 'flex',
    gap: 8,
  }),
  label: css({
    color: '#888',
    minWidth: 55,
  }),
  value: css({
    color: '#ddd',
  }),
  divider: css({
    height: 1,
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    margin: '4px 0',
  }),
};
